<template>
  <div class="default">
    <Header v-if="$route.meta.header" :path="$route.path" />

    <div class="shop-body">
      <main class="main">
        <div>
          <router-view></router-view>
        </div>
      </main>
    </div>
    <Footer v-if="$route.meta.footer" :path="$route.path" />
  </div>
</template>

<script>
import Header from "./../components/OnlineShop/Header.vue";
import Footer from "./../components/OnlineShop/Footer.vue";
export default {
  name: "ShopContainer",
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
.default {
  display: flex;
  flex-flow: column;
  overflow-x: hidden !important;
  overflow-y: hidden !important;

  .shop-body {
    min-height: calc(100vh - 322px);
    padding: 30px;
    margin-top: 100px;
    overflow-x: hidden !important;
    @media only screen and (max-width: 900px) {
      margin-top: 140px;
      min-height: calc(100vh - 480px);
      padding: 25px 10px;
      overflow-x: hidden !important;
    }
  }
}
</style>
